var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: "480px", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _c("div", { staticStyle: { color: "#797979" } }, [
                _vm._v("Đặt lại mật khẩu")
              ]),
              _c("v-spacer")
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-text",
            { staticClass: "py-8" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(" Mật khẩu "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Nhập mật khẩu tại đây",
                      "append-icon": _vm.showNewPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showNewPassword ? "text" : "password",
                      rules: _vm.passwordRules,
                      color: "primary",
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showNewPassword = !_vm.showNewPassword
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.newPassword,
                      callback: function($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword"
                    }
                  }),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v(" Mật khẩu (nhắc lại) "),
                    _c("span", { staticStyle: { color: "red" } }, [_vm._v("*")])
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      placeholder: "Nhập mật khẩu tại đây",
                      "append-icon": _vm.showConfirmPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showConfirmPassword ? "text" : "password",
                      rules: _vm.confirmPasswordRules,
                      color: "primary",
                      outlined: "",
                      "validate-on-blur": ""
                    },
                    on: {
                      "click:append": function($event) {
                        _vm.showConfirmPassword = !_vm.showConfirmPassword
                      },
                      keyup: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.submit.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.confirmPassword,
                      callback: function($$v) {
                        _vm.confirmPassword = $$v
                      },
                      expression: "confirmPassword"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "white--text text-subtitle-1 btn-text mt-6",
                  staticStyle: { width: "100%" },
                  attrs: {
                    depressed: "",
                    "x-large": "",
                    color: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.submit()
                    }
                  }
                },
                [_vm._v("Xác nhận ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }